import { render, staticRenderFns } from "./icon_mdi_exclamation_thick.vue?vue&type=template&id=36077e8e"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports